import _filter from "lodash/filter"
import _includes from "lodash/includes"
import _map from "lodash/map"
import _flatten from "lodash/flatten"
import pipe from "ramda/src/pipe"

import { phone } from "services/utils/mask"

import {
  CONTROLE,
  POSPAGO,
  TELEFONIA_MOVEL,
  PREPAGO,
  VOZ,
  TELEFONIA_FIXA
} from "services/state/billing/constants"

const details = [CONTROLE, PREPAGO, POSPAGO]
const lineOfBusinessAllow = [TELEFONIA_MOVEL, VOZ, TELEFONIA_FIXA]

const filterMobile = (data) =>
  _filter(data, (item) => _includes(lineOfBusinessAllow, item.lineOfBusiness))

const mapProducts = (data) => _map(data, (item) => item.products)

const filterDetails = (data) =>
  _filter(data, (itemMobile) => _includes(details, itemMobile.paymentMode))

export const filterOnlyMobileProductsWithDetail = (data) => {
  const dataMobile = pipe(
    filterMobile,
    mapProducts,
    _flatten,
    filterDetails
  )(data)

  return dataMobile
}

export const mapNumberAsOption = (products) =>
  _map(products, ({ serviceId, productKey }) => ({
    label: phone(serviceId),
    value: productKey
  }))



// WEBPACK FOOTER //
// ./src/scenes/DetailingPosPreControle/utils/handleGetMonthsDetailing.js